import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-2",
    userPoolId: "ap-southeast-2_K5aoDYo7l",
    userPoolWebClientId: "cdd8ot91f6fhaippi9jp0cclh",
  },
});

export default Amplify;
